import KeyValuePair from '@/modules/core/support/KeyValuePair';

/**
 * Traducción de un mensaje
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class MessageTranslation {

    constructor (public id = 0, public locale = '', public content = '') {}

    public static deserialize (data: KeyValuePair) {
        return new this(data.id, data.locale, data.content)
    }

    public serialize (): KeyValuePair {
        return {
            locale: this.locale,
            content: this.content,
        }
    }
}
